module.exports = {
      id: "gallery-usage",
      viewBox: "0 0 61 48",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#gallery",
      toString: function () {
        return this.url;
      }
    }